import { Card, CardBody } from "@heroui/react";
import React from "react";

function ProductAboutCard({
  title,
  desc,
  note,
  noCard,
}: {
  title?: string | React.ReactNode;
  desc?: string;
  note?: React.ReactNode;
  noCard?: boolean;
}) {
  return (
    <div className="rounded-xl overflow-hidden mb-4 ">
      {title && (
        <div className="px-8 py-2 border rounded-t-xl border-zinc-100 dark:border-zinc-500 w-full">
          <span className="text-primary">{title}</span>
        </div>
      )}
      {!noCard ? (
        <Card shadow="none" className="full rounded-none bg-zinc-50 dark:bg-zinc-700">
          <CardBody className="px-4 md:px-8 space-y-3">
            {desc && (
              <div className="">
                <div className="font-semibold mb-2 ">Description</div>
                <p className="text-zinc-700 dark:text-zinc-200">{desc}</p>
              </div>
            )}
            {note && <div className="text-zinc-700 dark:text-zinc-200">{note}</div>}
          </CardBody>
        </Card>
      ) : (
        <>
          {" "}
          {desc && (
            <div className="">
              <div className="font-semibold mb-2 ">Description</div>
              <p className="text-zinc-700 dark:text-zinc-200">{desc}</p>
            </div>
          )}
          {note && <div className="text-zinc-700 dark:text-zinc-200">{note}</div>}
        </>
      )}
    </div>
  );
}

export default ProductAboutCard;
